import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import {
  ContactKind,
  ContactKindSource,
  contactKind,
} from '@macs-frontend/features/shared/utils/contact-kind';

@Component({
  selector: 'md-contact-kind-badge',
  templateUrl: 'contact-kind-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactKindBadgeComponent extends BaseComponent {
  @Input()
  contact: ContactKindSource | null = null;

  @Input()
  clientUuid: string | null | undefined = null;

  get kind(): ContactKind {
    return contactKind(this.contact, this.clientUuid);
  }
}
